import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Glyphicon } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './NavMenu.css';

export class MenuItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLabel: false
        };
    }

    static contextTypes = {
        setSelectedMenuItem: PropTypes.func,
        setSelectedMenuItemTitle: PropTypes.func,
        showMetadataButton: PropTypes.bool,
        setShowMetadataButton: PropTypes.func
    }

    identifyComponent() {
        const { showMetadata, label, to } = this.props;
        const { setSelectedMenuItem, setSelectedMenuItemTitle, setShowMetadataButton } = this.context;

        setSelectedMenuItem(showMetadata ? to : undefined);
        setSelectedMenuItemTitle(showMetadata ? label : undefined);
        setShowMetadataButton(showMetadata);
    }

    expandLabelHandler() {
        this.setState({
            showLabel: true
        });
    }

    collapseLabelHandler() {
        this.setState({
            showLabel: false
        });
    }

    render() {
        const { showLabel } = this.state;
        const { icon, label, to, app, isGlyph, exact, hidden } = this.props;

        if (hidden) {
            return null;
        }

        return (
            <div className={`icon-nav-item-link ${app}`}>
                <LinkContainer className="icon-nav-item-link-container" key={`menu-item-${label.toLowerCase().replace(" ", "-")}`} to={to} exact={exact}>
                    <div className="icon-nav-item-link-content">
                        <div className="icon-nav-item-link-icon"
                            onClick={() => this.identifyComponent()}
                            onMouseLeave={() => this.collapseLabelHandler()}
                            onMouseEnter={() => this.expandLabelHandler()} >
                            {
                                undefined !== isGlyph && isGlyph === 'true'
                                    ?
                                    <Glyphicon glyph={icon}></Glyphicon>
                                    :
                                    <div className={icon}></div>
                            }
                        </div>

                        <div
                            className={showLabel ? "icon-nav-item-link-label-show" : "icon-nav-item-link-label-hide"}
                        >
                            {label}
                        </div>
                    </div>
                </LinkContainer>
            </div>
        );
    }
}
